<template>
  <v-container class="page">
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-card
      width="100%"
      style="border-radius:10px;"
      class="pa-3"
      v-show="!overlay"
    >
      <v-card-title class="title font-weight-light">
        Vehicle Accessories
        <v-spacer />
        <v-text-field
          v-model="searchData"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        />
      </v-card-title>
      <v-card-text>
        <div class="d-flex">
          <v-btn
            color="#00ACDC"
            dark
            class="mb-2 ml-auto"
            @click="createDialog = true"
          >
            CREATE NEW VEHICLE ACCESSORY
          </v-btn>
        </div>
        <v-data-table
          :headers="headers"
          :items="vehicleAccessory"
          class="font-weight-light pa-5"
          :loading="loadingType"
          loading-text="Loading..."
          :footer-props="footerProps"
          @update:options="updatePaging"
          :server-items-length="vehicleAccessoryTotal"
          :options.sync="paginationOptions"
        >
          <template #[`item.no`]=" { item }">
            {{ ((paginationOptions.page - 1) * paginationOptions.itemsPerPage) + vehicleAccessory.indexOf(item) + 1 }}
          </template>
          <template #[`item.is_vehicle`]="{ item }">
            {{ setIsVehicle(item) }}
          </template>
          <template #[`item.action`]="{ item }">
            <v-icon
              small
              class="mr-2"
              color="green"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              small
              color="red"
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <template #no-data>
            Asset type not available, please create a new vehicle accessory
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="deleteDialog"
      persistent
      max-width="550"
    >
      <v-card
        dark
        color="red"
      >
        <v-card-title>
          <span>
            <v-icon>mdi-alert-circle</v-icon> Are you sure to want to delete
            this vehicle accessory?
          </span>
        </v-card-title>
        <v-card-text>
          You will delete this vehicle accessory permanently.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="deleteDialog = false"
            text
          >
            No
          </v-btn>
          <v-btn
            @click="deleteVehicleAccessory"
            text
            :loading="loadingUpdate"
            :disabled="loadingUpdate"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="createDialog"
      max-width="500px"
      persistent
    >
      <v-card
        width="100%"
        style="border-radius:10px;"
        class="pa-10"
        outlined
      >
        <v-toolbar
          light
          flat
        >
          <v-spacer />
          <div class="pt-3">
            <p class="text-center headline">
              <v-icon
                color="#00ACDC"
                class="mx-2"
              >
                mdi-application
              </v-icon>Create Vehicle Accessory
            </p>
          </div>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card-text class="my-0">
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    outlined
                    hide-details
                    label="Name"
                    :rules="[(v) => !!v || 'Name is required']"
                    v-model="name"
                    required
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-row>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                block
                @click="close"
                type="submit"
                color="error"
              >
                CLOSE
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                block
                @click="save"
                type="submit"
                color="success"
                :loading="loadingUpdate"
                :disabled="loadingUpdate"
              >
                SUBMIT
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="editDialog"
      max-width="500px"
      persistent
    >
      <v-card
        width="100%"
        style="border-radius:10px;"
        class="pa-10"
        outlined
      >
        <v-toolbar
          light
          flat
        >
          <v-spacer />
          <div class="pt-3">
            <p class="text-center headline">
              <v-icon
                color="#00ACDC"
                class="mx-2"
              >
                mdi-application
              </v-icon>Update vehicle accessory
            </p>
          </div>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card-text class="px-0 py-0">
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    outlined
                    hide-details
                    label="Name"
                    :rules="[(v) => !!v || 'Name is required']"
                    v-model="editedItem.name"
                    required
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-row>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                block
                @click="closeEdit"
                type="submit"
                color="error"
              >
                CLOSE
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                block
                @click="saveEdit"
                type="submit"
                color="success"
                :loading="loadingUpdate"
                :disabled="loadingUpdate"
              >
                SUBMIT
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
/* eslint-disable */

const qs = require("qs");

export default {
  data: () => ({
    token: "",
    clientid: "",
    headers: [
      { text: "No", value: "no", sortable: false },
      { text: "Name", align: "left", value: "name" },
      { text: "Actions", value: "action", sortable: false },
    ],
    deleteDialog: false,
    searchData: "",
    searchDataTimeout: null,
    createDialog: false,
    editDialog: false,
    deletedIndex: 0,
    deletedItem: {},
    editedIndex: 0,
    editedItem: {
      id: "",
      name: "",
    },
    vehicleAccessory: [],
    vehicleAccessoryTotal: 0,
    valid: true,
    name: "",
    loadingType: false,
    loadingUpdate: false,
    loader: null,
    overlay: false,
    footerProps: {
      itemsPerPageOptions: [2, 3, 5, 10, 20, 50, 100, 200, 500]
    },
    paginationOptions: {
      sortBy: [],
      sortDesc: [],
      page: 1,
      itemsPerPage: 10
    },
  }),
  mounted() {
    this.getVehicleAccessoryTotal();
    this.getVehicleAccessory();
  },
  created() {
    this.token = this.$store.state.token;
    this.clientid = this.$store.state.clientid;
    this.overlay = true;
  },
  methods: {
    saveEdit() {
      if (this.$refs.form.validate()) {
        const item = this.vehicleAccessory.find((d) => d.id == this.editedItem.id);

        let isVehicle = "";
        this.editedItem.isVehicle === false
          ? (isVehicle = "0")
          : (isVehicle = "1");

        let is_hide_in_booking = "";
        this.editedItem.is_hide_in_booking === false
          ? (is_hide_in_booking = "0")
          : (is_hide_in_booking = "1");

        const datas = {
          clientid: this.clientid,
          id: item.id,
          name: this.editedItem.name,
        };

        this.loadingUpdate = true;
        this.loader = this.loadingUpdate;

        this.$store.dispatch('API_CALL', {
            $method: 'update_vehicle_accessory',
            $postData: {
              data: datas,
            },
          })
          .then(
						(response) => {
							if(response.data.code == 200) {
                this.$swal({
                  icon: 'success',
                  title: response.data.data.message,
                }).then((res) => {
                  if (res.isConfirmed) {
                    this.loadingUpdate = false;
                    this.loader = this.loadingUpdate;
                    this.editDialog = false;
                    this.getVehicleAccessoryTotal();
                    this.getVehicleAccessory();
                  }
                })
              } else {
                this.$swal({
                  icon: 'error',
                  title: response.data.data.message,
                })
                .then((res) => {
                  if (res.isConfirmed) {
                    this.getVehicleAccessoryTotal();
                    this.getVehicleAccessory();
                  }
                })
              }
            })
      }
    },
    save() {
      if (this.$refs.form.validate()) {
        this.payloadApi = {
          clientid: this.clientid,
          name: this.name,
        };
        this.loadingUpdate = true;
        this.loader = this.loadingUpdate;
        this.$store.dispatch('API_CALL', {
            $method: 'create_vehicle_accessory',
            $postData: {
              data: this.payloadApi,
            },
          })
          .then(
          (response) => {
            if(response.data.code == 200) {
              this.$swal({
                icon: 'success',
                title: response.data.data.message,
              }).then((res) => {
                if (res.isConfirmed) {
                  this.loadingUpdate = false;
                  this.loader = this.loadingUpdate;
                  this.close();
                  this.getVehicleAccessoryTotal();
                  this.getVehicleAccessory();
                  this.$refs.form.reset();
                }
              })
            } else {
              this.$swal({
                icon: 'error',
                title: response.data.data.message,
              }).then((res) => {
                if (res.isConfirmed) {
                  this.loadingUpdate = false;
                  this.loader = this.loadingUpdate;
                  this.getVehicleAccessoryTotal();
                  this.getVehicleAccessory();
                }
              })
            }
          })
      }
    },
    close() {
      this.createDialog = false;
      this.name = ""
    },
    closeEdit() {
      this.editDialog = false;
    },
    getVehicleAccessoryTotal() {
      return this.$store.dispatch('API_CALL', {
        $method: 'get_vehicle_accessory_total',
        $postData: {
          clientid: this.$store.state.clientid,
          query: this.searchData
        },
      }).then((response) => {
        this.vehicleAccessoryTotal = parseInt(response.data.data.total);
      })
    },
    getVehicleAccessory() {
      if (this.loadingType) return
      this.loadingType = true;

      const { page, itemsPerPage, sortBy, sortDesc } = this.paginationOptions;
      const sort_by  = sortBy.length ? sortBy[0] : 'name';
      const sort_dir = sortDesc.length ? (sortDesc[0] ? 'desc' : 'asc') : 'asc';
      const offset   = (page - 1) * itemsPerPage;

      return this.$store.dispatch('API_CALL', {
          $method: 'get_vehicle_accessory',
          $postData: {
            clientid: this.$store.state.clientid,
            limit: itemsPerPage,
            offset,
            sort_by,
            sort_dir,
            query: this.searchData
          },
        })
        .then((response) => {
          this.loadingType = false;
          this.vehicleAccessory = response.data.data;
        });
    },
    deleteItem(item) {
      this.deleteDialog = true;
      this.deletedIndex = this.vehicleAccessory.indexOf(item);
      this.deletedItem = Object.assign({}, item);
    },
    editItem(item) {
      this.editDialog = true;
      this.editedIndex = this.vehicleAccessory.indexOf(item);
      this.editedItem.id = item.id;
      this.editedItem.name = item.name;
    },
    deleteVehicleAccessory() {
      const item = this.vehicleAccessory.find((d) => d.id == this.deletedItem.id);
      this.deleteDialog = false;

      this.loadingUpdate = true;
      this.loader = this.loadingUpdate;
      return this.$store.dispatch('API_CALL', {
          $method: 'delete_vehicle_accessory',
          $postData: {
            data: {
              id: item.id,
              clientid: this.clientid,
            }
          },
        })
        .then(
          (response) => {
            if(response.data.code == 200) {
              this.$swal({
                icon: 'success',
                title: response.data.data.message,
              })
              this.loadingUpdate = false;
              this.loader = this.loadingUpdate;
              Promise.all([
                this.getVehicleAccessoryTotal(),
                this.getVehicleAccessory(),
              ]).then(() => {
                if (this.vehicleAccessoryTotal > 0 && this.vehicleAccessory.length === 0) {
                  this.paginationOptions.page = 1
                  this.getVehicleAccessory();
                }
              })
            } else {
              this.$swal({
                icon: 'error',
                title: response.data.data.message,
              })
              this.loadingUpdate = false;
              this.loader = this.loadingUpdate;
            }
          })
    },
    setIsVehicle(item) {
      return item.is_vehicle === "0" ? "No" : "Yes";
    },
    updatePaging(options) {
      this.getVehicleAccessoryTotal();
      this.paginationOptions = options;
      this.getVehicleAccessory();
    },
  },
  computed: {},
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 500);

      this.loader = null;
    },
    overlay(val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 500)
    },
    searchData() {
      clearTimeout(this.searchDataTimeout)
      this.searchDataTimeout = setTimeout(() => {
        this.paginationOptions.page     = 1;
        this.paginationOptions.sortBy   = [];
        this.paginationOptions.sortDesc = [];
        this.getVehicleAccessoryTotal();
        this.getVehicleAccessory();
      }, 1e3)
    }
  },
};
</script>
<style lang="css" scoped></style>
